import {
    Component,
    Optional,
    Inject,
    Input,
    ViewChild,
} from '@angular/core';

import {
    NgModel,
    NG_VALUE_ACCESSOR,
    NG_VALIDATORS,
    NG_ASYNC_VALIDATORS,
    ControlValueAccessor
} from '@angular/forms';

import { ValueAccessorBase, animations } from '../';

declare var $: any;

@Component({
    selector: 'itpx-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.css'],
    animations,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: AutocompleteComponent,
        multi: true,
    }],
})
export class AutocompleteComponent implements ControlValueAccessor {

    @Input() public placeholder: string;
    @Input() public reverse: boolean;
    @Input() public source: any;
    @Input() public disabled: boolean;
    @Input() public allowSingleSelection: boolean = false;
    @Input() public disableCreateNewItem: boolean = false;
    @Input() public description: string = null;
    @Input() public maxLength: number = 0;
    @Input() public maxLengthErrorMessage: string = `Keyword cannot exceed limit of 255 characters`;
    private innerValue: string[] = [];
    private items: string[] = [];
    private $autocomplete: any;
    query: string;

    @ViewChild(NgModel) model: NgModel;
    @ViewChild('autocomplete') autocomplete;

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>
    ) { }

    ngAfterViewInit() {
        let self = this;
        this.$autocomplete = $(this.autocomplete.nativeElement)
            .autocomplete({
                source: self.source,
                minLength: 0,
                maxLength: 1,
                autoFocus: true,
                response: (event, ui) => {
                    const val = this.$autocomplete.val();
                    // condition purpose is to hide new pop-up on keywords length extends
                    let isKeywordLengthExtends = (this.maxLength && val && val.length>this.maxLength) || false;
                    if (!this.disableCreateNewItem) {
                        if (!isKeywordLengthExtends && (val && val.length >= 3) &&
                            ((this.innerValue.indexOf(val) < 0 && ui.content.length === 0) || this.showNew(ui.content, val))) {
                            ui.content.unshift({
                                label: 'Create new: ' + val,
                                value: val,
                                id: 0
                            });
                        }
                    } else if (ui.content.length === 0) {
                        // 'result not found' option will be visible when disableCreateNewItem is true and we get no value from the services
                        let noResult = { value: null, label: "No results found" };
                        ui.content.push(noResult);
                    }
                }
            })
            .on('autocompleteselect', function (event, ui) {
                let item = ui.item as SelectedItem;
                self.onSelect(item.value);
                $(this).val('');
                return true;
            });
    }

    private onSelect(item: any) {
        let items = this.value;
        if (items.indexOf(item) > -1) return;
        if (this.allowSingleSelection) {
            if (!item) {
                return
            } else if (items.length) {
                items = [];
            }
        }
        if (this.reverse) {
            items.push(item);
        } else {
            items.unshift(item);
        }

        this.value = items;
    }

    private onRemove(item: string) {
        let items = this.value;
        items = items.slice();
        let index = items.indexOf(item, 0);
        if (index > -1) items.splice(index, 1);
        this.value = items;
    }

    private showNew(arr: any[], key: string) {
        let result = true;
        if (this.innerValue.indexOf(key) > -1) return false;
        arr.forEach(_ => {
            if (_.value == key) {
                result = false;
                return;
            }
        });
        return result;
    }

    private changed = new Array<(value: string[]) => void>();
    private touched = new Array<() => void>();

    get value(): string[] {
        return this.innerValue;
    }

    set value(value: string[]) {
        if (!value || typeof value === 'string') return;
        this.innerValue = value;
        this.query = '';
        this.changed.forEach(f => f(value));
    }

    writeValue(value: string[]) {
        if (!value || typeof value === 'string') return;
        this.innerValue = value;
        this.query = '';
    }

    registerOnChange(fn: (value: string[]) => void) {
        this.changed.push(fn);
    }

    registerOnTouched(fn: () => void) {
        this.touched.push(fn);
    }

    touch() {
        this.touched.forEach(f => f());
    }
}

export class SelectedItem {
    constructor(public value: string, public color: string) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/controls/autocomplete/autocomplete.component.ts